import { WindowSize } from '../types/windowSize'

export const getCurrentScreenSize = (): WindowSize => ({
  width: window.screen.width,
  height: window.screen.height,
})
